module.exports = __webpack_public_path__ + "img/shopping_cart.34789a75.svg";